import { Flex, useDisclosure, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { Button } from '@ubirider/pick-component-library'
import React from 'react'
import { motion } from 'motion/react'

import { SettleAmountModal } from '../../../../modals/SettleAmountModal'
import { useCards, useTrips } from '../../../../context/DataProvider'
import { NoCardsModal } from '../../../../modals/NoCardsModal'
import { formatCurrency } from '../../../../helpers/currency'

// Criar o componente animável
const MFlex = motion.create(Flex)

// Variantes de animação baseadas no InfoSection
const barVariants = {
  hidden: { opacity: 0, y: 10, scale: 0.98 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      type: 'spring',
      stiffness: 360,
      damping: 26,
      delay: 0.1 // Pequeno delay para entrar após o layout base
    },
  }
}

export const PaymentDueBar = () => {
  const { t } = useTranslation()

  const { isOpen, onOpen, onClose } = useDisclosure()
  const { isOpen: isOpenNoCards, onOpen: onOpenNoCards, onClose: onCloseNoCards } = useDisclosure()

  const { trips } = useTrips()
  const { cards } = useCards()

  const unpaidTrips = trips.filter(trip => trip.status === 'not_paid')

  const totalAmount = formatCurrency(
    unpaidTrips.reduce((acc, trip) => acc + Math.round(parseFloat(trip.amount || 0) * 100), 0)
  )

  return (
    <>
      {unpaidTrips.length > 0 && (
        <MFlex
          direction='column'
          w='100%'
          border='1px danger.200'
          bg='danger.100'
          padding='24px'
          gap='16px'
          rounded='8px'
          // Props de animação
          initial='hidden'
          animate='visible'
          variants={barVariants}
        >
          <Flex w='100%' justify='space-between'>
            <Text fontSize={{ sm: '18px', lg: '24px' }} fontWeight='700'>
              {t('acqua_vias.home_amount_to_pay_title')}
            </Text>
            <Text fontSize={{ sm: '18px', lg: '24px' }} fontWeight='700' color='danger.600'>
              R$ {totalAmount}
            </Text>
          </Flex>
          <Text fontSize={{ sm: '13px', lg: '14px' }}>{t('acqua_vias.home_amount_to_pay_description')}</Text>

          <Flex display={{ sm: 'none', lg: 'flex' }} justify='flex-end'>
            <Button
              onClick={cards.length > 0 ? onOpen : onOpenNoCards}
              type='neutralDark'
              style='solid'
              label={t('acqua_vias.pay_button')}
            />
          </Flex>
          <Flex display={{ sm: 'flex', lg: 'none' }}>
            <Button
              onClick={cards.length > 0 ? onOpen : onOpenNoCards}
              type='neutralDark'
              style='solid'
              label={t('acqua_vias.pay_button')}
              css={{ width: '100%' }}
            />
          </Flex>
        </MFlex>
      )}

      <NoCardsModal isOpen={isOpenNoCards} onOpen={onOpenNoCards} onClose={onCloseNoCards} />
      <SettleAmountModal
        trips={unpaidTrips}
        totalAmount={totalAmount}
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
      />
    </>
  )
}